import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";

const BENEFITS = [
  { key: "lp1_service1" },
  { key: "lp1_service2" },
  { key: "lp1_service3" },
];

function SectionThree() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const breakpoints = {
    1200: {
      slidesPerView: 3,
    },
    1000: {
      spaceBetween: 20,
    },
    900: {
      slidesPerView: 3,
    },
    700: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="benefits" className={`sectionThree ${isVisible ? "visible" : ""}`}>
        <div className="sectionThreeTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp1_benefits_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp1_benefits_subtitle")}
          </p>
        </div>
        <Swiper
          slidesPerView={3}
          spaceBetween={40}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={false}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {BENEFITS.map((benefit) => (
            <SwiperSlide key={benefit.key}>
              <div className={`card1 card ${isVisible ? "visible" : ""}`}>
                <p className="cardTitle">{t(`${benefit.key}_title`)}</p>
                <p>{t(`${benefit.key}_text`)}</p>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default SectionThree;
